import { motion } from "framer-motion";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";

export default function PolitiqueConfidentialitePage() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-[#F5F5F0]"
    >
      <Navbar />
      <SEO
        path="/politique-confidentialite"
        title="Politique de Confidentialité — PROBWA La Réunion"
        description="Politique de confidentialité de PROBWA — Eco Bois Concept. Découvrez comment nous protégeons vos données personnelles conformément au RGPD."
      />
      <main className="pt-24">
        {/* Hero */}
        <section className="py-12 md:py-16 bg-[#2D2D2D]">
          <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-4xl md:text-5xl font-bold text-[#E8E8E8]"
              style={{ fontFamily: "'DM Serif Display', serif" }}
              data-testid="politique-confidentialite-title"
            >
              Politique de <span className="text-[#8BC34A]">Confidentialité</span>
            </motion.h1>
            <p className="text-[#9E9E9E] mt-4">
              Charte de Protection des Données Personnelles
            </p>
          </div>
        </section>

        {/* Content */}
        <section className="py-16 md:py-24">
          <div className="max-w-4xl mx-auto px-6 md:px-12">
            <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl space-y-8">
              
              <p className="text-[#3A3A3A] leading-relaxed">
                La présente politique de confidentialité définit et vous informe de la manière 
                dont <strong>PROBWA</strong> utilise et protège les informations que vous nous 
                transmettez, le cas échéant, lorsque vous utilisez le présent site accessible 
                à partir de l'URL suivante : www.probwa.re (ci-après le « Site »).
              </p>

              <p className="text-[#3A3A3A] leading-relaxed">
                Veuillez noter que cette politique de confidentialité est susceptible d'être 
                modifiée ou complétée à tout moment par PROBWA, notamment en vue de se conformer 
                à toute évolution législative, réglementaire, jurisprudentielle ou technologique. 
                La date de mise à jour sera clairement identifiée en bas de la présente politique.
              </p>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  1. IDENTITÉ DU RESPONSABLE DE TRAITEMENT
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  Le responsable du traitement des données personnelles est :<br /><br />
                  <strong>PROBWA</strong><br />
                  Société au capital de 900 euros<br />
                  R.C.S. : 982 037 558 R.C.S. Saint Denis de La Réunion<br />
                  Siège social : 7 RUE ELIE EUDOR BUREAU N3, 97460 SAINT-PAUL, La Réunion<br />
                  Représentée par Isaac RODRIGUEZ LOPEZ<br /><br />
                  <strong>Contact DPO :</strong> probwalareunion@gmail.com
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  2. DONNÉES COLLECTÉES
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed mb-4">
                  Nous collectons les données personnelles suivantes lorsque vous utilisez 
                  notre formulaire de demande de devis :
                </p>
                <ul className="list-disc list-inside text-[#3A3A3A] space-y-2 ml-4">
                  <li>Nom et prénom</li>
                  <li>Adresse email</li>
                  <li>Numéro de téléphone</li>
                  <li>Description de votre projet</li>
                  <li>Type de produits souhaités</li>
                </ul>
                <p className="text-[#3A3A3A] leading-relaxed mt-4">
                  Ces données sont collectées uniquement lorsque vous nous les fournissez 
                  volontairement via notre formulaire de contact ou de demande de devis.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  3. FINALITÉS DU TRAITEMENT
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed mb-4">
                  Vos données personnelles sont collectées pour les finalités suivantes :
                </p>
                <ul className="list-disc list-inside text-[#3A3A3A] space-y-2 ml-4">
                  <li>Répondre à vos demandes de devis et d'information</li>
                  <li>Vous contacter concernant votre projet</li>
                  <li>Assurer le suivi de la relation commerciale</li>
                  <li>Établir des devis et factures</li>
                  <li>Améliorer nos services et notre site web</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  4. BASE JURIDIQUE DU TRAITEMENT
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  Conformément au Règlement Général sur la Protection des Données (RGPD), 
                  le traitement de vos données personnelles est fondé sur :<br /><br />
                  • <strong>Votre consentement</strong> lorsque vous remplissez un formulaire de demande de devis<br />
                  • <strong>L'exécution de mesures précontractuelles</strong> prises à votre demande<br />
                  • <strong>L'intérêt légitime</strong> de PROBWA pour gérer sa relation client
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  5. DESTINATAIRES DES DONNÉES
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  Vos données personnelles sont destinées uniquement aux personnes habilitées 
                  au sein de PROBWA.<br /><br />
                  <strong>Nous ne vendons, ne louons ni ne partageons vos données personnelles 
                  avec des tiers à des fins commerciales.</strong><br /><br />
                  Vos données peuvent toutefois être communiquées, le cas échéant, à nos 
                  sous-traitants techniques (hébergeur) dans le strict cadre de leurs missions 
                  et dans le respect du RGPD.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  6. DURÉE DE CONSERVATION
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  Vos données personnelles sont conservées pendant une durée de :<br /><br />
                  • <strong>3 ans</strong> à compter de notre dernier contact pour les prospects<br />
                  • <strong>5 ans</strong> à compter de la fin de la relation commerciale pour les clients<br />
                  • <strong>10 ans</strong> pour les documents comptables conformément aux obligations légales<br /><br />
                  Au-delà de ces durées, vos données seront supprimées ou anonymisées.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  7. VOS DROITS
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed mb-4">
                  Conformément au RGPD et à la loi Informatique et Libertés, vous disposez des 
                  droits suivants concernant vos données personnelles :
                </p>
                <ul className="list-disc list-inside text-[#3A3A3A] space-y-2 ml-4">
                  <li><strong>Droit d'accès :</strong> obtenir la confirmation que vos données sont traitées et en obtenir une copie</li>
                  <li><strong>Droit de rectification :</strong> faire corriger vos données inexactes ou incomplètes</li>
                  <li><strong>Droit à l'effacement :</strong> demander la suppression de vos données (« droit à l'oubli »)</li>
                  <li><strong>Droit à la limitation :</strong> demander la suspension du traitement de vos données</li>
                  <li><strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré</li>
                  <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
                  <li><strong>Droit de retirer votre consentement :</strong> à tout moment</li>
                </ul>
                <p className="text-[#3A3A3A] leading-relaxed mt-4">
                  Pour exercer ces droits, vous pouvez nous contacter :<br /><br />
                  <strong>Par email :</strong> probwalareunion@gmail.com<br />
                  <strong>Par courrier :</strong> PROBWA - 7 RUE ELIE EUDOR BUREAU N3, 97460 SAINT-PAUL, La Réunion<br /><br />
                  Vous disposez également du droit d'introduire une réclamation auprès de la 
                  CNIL (Commission Nationale de l'Informatique et des Libertés) : www.cnil.fr
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  8. SÉCURITÉ DES DONNÉES
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  PROBWA met en œuvre toutes les mesures techniques et organisationnelles 
                  appropriées pour assurer la sécurité et la confidentialité de vos données 
                  personnelles, et notamment :<br /><br />
                  • Hébergement sécurisé chez OVH en France<br />
                  • Protocole HTTPS pour le transfert sécurisé des données<br />
                  • Accès restreint aux données personnelles aux seules personnes habilitées<br />
                  • Sauvegarde régulière des données
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  9. COOKIES
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  Notre site peut utiliser des cookies pour améliorer votre expérience de navigation.<br /><br />
                  <strong>Cookies nécessaires :</strong> essentiels au fonctionnement du site, 
                  ils ne peuvent pas être désactivés.<br /><br />
                  <strong>Cookies analytiques :</strong> nous aident à comprendre comment les 
                  visiteurs interagissent avec le site (nombre de visiteurs, pages consultées, etc.).<br /><br />
                  Vous pouvez à tout moment modifier vos préférences en matière de cookies 
                  via les paramètres de votre navigateur.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  10. TRANSFERT DE DONNÉES HORS UE
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  Vos données personnelles sont hébergées en France et ne font l'objet d'aucun 
                  transfert en dehors de l'Union Européenne.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  11. CONTACT
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  Pour toute question relative à la présente politique de confidentialité ou 
                  pour toute demande relative à vos données personnelles, vous pouvez nous contacter :<br /><br />
                  <strong>PROBWA</strong><br />
                  7 RUE ELIE EUDOR BUREAU N3<br />
                  97460 SAINT-PAUL, La Réunion<br /><br />
                  Email : probwalareunion@gmail.com<br />
                  Téléphone : +262 692 50 26 85
                </p>
              </div>

              <div className="pt-4 border-t border-gray-200">
                <p className="text-sm text-[#9E9E9E]">
                  Dernière mise à jour : Février 2026
                </p>
              </div>

            </div>
          </div>
        </section>
      </main>
      <Footer />
    </motion.div>
  );
}
